"use strict";

require("core-js/modules/es.array.reduce.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _ContactFormInput = _interopRequireDefault(require("./components/ContactFormInput"));

var _api = require("../../utils/api");

require("./ContactForm.css");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var ContactForm = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ContactForm, _React$Component);

  var _super = _createSuper(ContactForm);

  function ContactForm(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ContactForm);
    _this = _super.call(this, props);
    _this.state = _this.createInitialState();
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.toggleOptIn = _this.toggleOptIn.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSubmit = _this.handleSubmit.bind((0, _assertThisInitialized2["default"])(_this));
    _this.clearInputs = _this.clearInputs.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setInlineMessage = _this.setInlineMessage.bind((0, _assertThisInitialized2["default"])(_this));
    _this.inputShouldDisplayError = _this.inputShouldDisplayError.bind((0, _assertThisInitialized2["default"])(_this));
    _this.initializeContactForm = _this.initializeContactForm.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(ContactForm, [{
    key: "onChange",
    value: function onChange(e, _ref) {
      var name = _ref.name,
          value = _ref.value;
      var fields = this.state.fields;
      this.setInlineMessage('');
      this.setState({
        displayFieldErrors: false,
        fields: _objectSpread({}, fields, (0, _defineProperty2["default"])({}, name, value))
      });
    }
  }, {
    key: "setInlineMessage",
    value: function setInlineMessage(msg) {
      var _this2 = this;

      var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var messageTimeout = this.props.messageTimeout;
      this.setState({
        inlineMessage: msg,
        inlineMessageClass: className
      });

      if (className !== 'green' && msg !== '') {
        setTimeout(function () {
          return _this2.setState({
            inlineMessage: ''
          });
        }, messageTimeout);
      }
    }
  }, {
    key: "toggleOptIn",
    value: function toggleOptIn() {
      this.setState(function (prevState) {
        var fields = prevState.fields;
        return {
          displayFieldErrors: false,
          fields: _objectSpread({}, fields, {
            contact_opt_in: !fields.contact_opt_in
          })
        };
      });
    }
  }, {
    key: "createFieldGroups",
    value: function createFieldGroups(fields) {
      return fields.reduce(function (acc, _, i) {
        return i % 2 ? acc : [].concat((0, _toConsumableArray2["default"])(acc), [fields.slice(i, i + 2)]);
      }, []);
    }
  }, {
    key: "resetErrorState",
    value: function resetErrorState() {
      this.setState({
        displayFieldErrors: false,
        loading: false
      });
    }
  }, {
    key: "clearInputs",
    value: function clearInputs() {
      var fields = this.props.fields;
      var formFieldState = fields.reduce(function (acc, _ref2) {
        var label = _ref2.label;
        return _objectSpread({}, acc, (0, _defineProperty2["default"])({}, label, ''));
      }, {});
      this.setState({
        fields: formFieldState
      });
    }
  }, {
    key: "createInitialState",
    value: function createInitialState() {
      var _this$props = this.props,
          fields = _this$props.fields,
          termsCopy = _this$props.termsCopy;
      var formFieldState = fields.reduce(function (acc, _ref3) {
        var label = _ref3.label,
            value = _ref3.value;
        return _objectSpread({}, acc, (0, _defineProperty2["default"])({}, label, value));
      }, {});
      var additionalState = {
        inlineMessageClass: '',
        inlineMessage: '',
        displayFieldErrors: false,
        loading: false
      };
      var acceptTermsState = termsCopy ? {
        acceptedTerms: false
      } : {};
      return _objectSpread({
        fields: _objectSpread({}, formFieldState)
      }, additionalState, {}, acceptTermsState);
    }
  }, {
    key: "initializeContactForm",
    value: function initializeContactForm() {
      var initState = this.createInitialState();
      this.setState(initState);
    }
  }, {
    key: "areAllRequiredFieldsFilled",
    value: function areAllRequiredFieldsFilled() {
      var fields = this.state.fields;
      var fieldsProps = this.props.fields;
      return fieldsProps.filter(function (field) {
        return field.required && !fields[field.label];
      }).length === 0;
    }
  }, {
    key: "inputShouldDisplayError",
    value: function inputShouldDisplayError(field) {
      var _this$state = this.state,
          displayFieldErrors = _this$state.displayFieldErrors,
          fields = _this$state.fields;
      return field.required && displayFieldErrors && !fields[field.label];
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this3 = this;

      var _this$props2 = this.props,
          onSubmit = _this$props2.onSubmit,
          onSubmitSuccess = _this$props2.onSubmitSuccess,
          onSubmitError = _this$props2.onSubmitError,
          locationId = _this$props2.locationId,
          businessId = _this$props2.businessId,
          businessType = _this$props2.businessType,
          emailSubject = _this$props2.emailSubject;
      var _this$state$fields = this.state.fields,
          email = _this$state$fields.email,
          name = _this$state$fields.name,
          _this$state$fields$me = _this$state$fields.message,
          message = _this$state$fields$me === void 0 ? '' : _this$state$fields$me,
          contactOptIn = _this$state$fields.contact_opt_in;

      if (this.areAllRequiredFieldsFilled()) {
        this.setState({
          loading: true
        }, function () {
          var onSubmitParams = {
            businessType: businessType,
            businessId: businessId,
            locationId: locationId,
            name: name,
            email: email,
            emailSubject: emailSubject,
            message: message,
            contactOptIn: contactOptIn
          };
          onSubmit(onSubmitParams).then(function () {
            _this3.clearInputs();

            _this3.setInlineMessage('Successfully sent!', 'green');

            _this3.resetErrorState();

            if (onSubmitSuccess) {
              onSubmitSuccess();
            }
          })["catch"](function () {
            if (onSubmitError) {
              onSubmitError();
            }

            _this3.setInlineMessage('Unknown error sending contact form. Please try again later.', 'red');

            _this3.resetErrorState();
          });
        });
      } else {
        this.setInlineMessage('Please fill in all required fields!', 'red');
        this.setState({
          displayFieldErrors: true,
          loading: false
        });
      }
    }
  }, {
    key: "mapFieldsToInputGroup",
    value: function mapFieldsToInputGroup(fields) {
      var _this4 = this;

      var showLabels = this.props.showLabels;
      var allFields = this.state.fields;
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Group, {
        widths: "equal",
        key: fields[0].label
      }, fields.map(function (field) {
        return /*#__PURE__*/_react["default"].createElement(_ContactFormInput["default"], {
          showLabels: showLabels,
          field: field,
          value: allFields[field.label],
          onChange: _this4.onChange,
          error: _this4.inputShouldDisplayError(field)
        });
      }));
    }
  }, {
    key: "renderForms",
    value: function renderForms() {
      var _this5 = this;

      var disabledInputs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _this$props3 = this.props,
          fields = _this$props3.fields,
          inline = _this$props3.inline,
          showLabels = _this$props3.showLabels;
      var allFields = this.state.fields; // Create chunks of two forms per group

      var fieldGroups = this.createFieldGroups(fields); // Wrap fields with form components

      var formGroups = fieldGroups.map(function (fieldGroup) {
        return _this5.mapFieldsToInputGroup(fieldGroup);
      });
      var forms = fields.map(function (field) {
        return /*#__PURE__*/_react["default"].createElement(_ContactFormInput["default"], {
          showLabels: showLabels,
          field: field,
          value: allFields[field.label],
          disabled: disabledInputs,
          onChange: _this5.onChange,
          error: _this5.inputShouldDisplayError(field)
        });
      });
      var fieldsWithForms = inline ? formGroups : forms;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, fieldsWithForms, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, {
        disabled: disabledInputs
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Checkbox, {
        name: "contact_opt_in",
        label: 'By entering your information, you permit us to reach out to you' + ' with future communications.',
        onChange: this.toggleOptIn,
        checked: allFields.contact_opt_in
      })));
    }
  }, {
    key: "renderTOS",
    value: function renderTOS() {
      var termsCopy = this.props.termsCopy;
      var acceptTerms = this.state.acceptTerms;
      return termsCopy && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, {
        control: _semanticUiReact.Checkbox,
        label: termsCopy,
        value: acceptTerms,
        onChange: this.onChange
      });
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _this$props4 = this.props,
          header = _this$props4.header,
          subheader = _this$props4.subheader,
          centeredHeaders = _this$props4.centeredHeaders;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, header && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
        as: "h1",
        textAlign: centeredHeaders ? 'center' : 'left'
      }, header), subheader && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
        as: "h3",
        textAlign: centeredHeaders ? 'center' : 'left'
      }, subheader));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          buttonText = _this$props5.buttonText,
          className = _this$props5.className,
          fluidButton = _this$props5.fluidButton,
          withContainer = _this$props5.withContainer,
          button = _this$props5.button;
      var _this$state2 = this.state,
          loading = _this$state2.loading,
          inlineMessage = _this$state2.inlineMessage,
          inlineMessageClass = _this$state2.inlineMessageClass;
      var isSuccessMsg = inlineMessageClass === 'green';

      var form = /*#__PURE__*/_react["default"].createElement("div", {
        className: className
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form, {
        loading: loading,
        success: isSuccessMsg,
        error: !isSuccessMsg
      }, this.renderHeader(), this.renderForms(isSuccessMsg), this.renderTOS(), /*#__PURE__*/_react["default"].createElement("div", null, inlineMessage && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Message, {
        success: isSuccessMsg,
        negative: !isSuccessMsg
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Message.Content, null, inlineMessage, isSuccessMsg && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, ' ', /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
        name: "check circle outline"
      })))), button && !isSuccessMsg && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        onClick: this.handleSubmit,
        primary: true,
        fluid: fluidButton
      }, buttonText), button && isSuccessMsg && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        onClick: this.initializeContactForm,
        primary: true,
        fluid: fluidButton
      }, "Send Another Message"))));

      return withContainer ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Container, null, form) : {
        form: form
      };
    }
  }]);
  return ContactForm;
}(_react["default"].Component);

exports["default"] = ContactForm;
ContactForm.propTypes = {
  locationId: _propTypes["default"].number.isRequired,
  businessId: _propTypes["default"].number.isRequired,
  businessType: _propTypes["default"].string.isRequired,
  emailSubject: _propTypes["default"].string,
  fields: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    placeholder: _propTypes["default"].string,
    value: _propTypes["default"].string,
    type: _propTypes["default"].oneOf(['input', 'textarea', 'select', 'hidden']),
    inputType: _propTypes["default"].string,
    options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      label: _propTypes["default"].string,
      value: _propTypes["default"].string
    }))
  })),
  onSubmit: _propTypes["default"].func,
  onSubmitSuccess: _propTypes["default"].func,
  onSubmitError: _propTypes["default"].func,
  messageTimeout: _propTypes["default"].number,
  buttonText: _propTypes["default"].string,
  centeredHeaders: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  fluidButton: _propTypes["default"].bool,
  button: _propTypes["default"].bool,
  header: _propTypes["default"].string,
  inline: _propTypes["default"].bool,
  showLabels: _propTypes["default"].bool,
  subheader: _propTypes["default"].string,
  termsCopy: _propTypes["default"].string,
  withContainer: _propTypes["default"].bool
};
ContactForm.defaultProps = {
  emailSubject: '',
  fields: [{
    label: 'name',
    placeholder: 'Name',
    type: 'input',
    required: true
  }, {
    label: 'email',
    placeholder: 'you@gmail.com',
    type: 'input',
    inputType: 'email',
    required: true
  }, {
    label: 'message',
    placeholder: 'Message',
    type: 'textarea',
    required: false
  }],
  onSubmit: _api.sendContactFormEmail,
  onSubmitSuccess: null,
  onSubmitError: null,
  messageTimeout: 10000,
  buttonText: 'Submit',
  centeredHeaders: false,
  className: '',
  fluidButton: false,
  button: true,
  header: '',
  inline: false,
  showLabels: false,
  subheader: '',
  termsCopy: '',
  withContainer: true
};
ContactForm.propOptions = {
  header: ['Contact Form', 'Contact Us'],
  termsCopy: ['Accept the Terms of Service', '']
};
ContactForm.dataPropsMap = {};